export const GENERAL_TAB_LABELS: { [key: string]: string } = {
  id: 'ID',
  uniqueId: 'Unique ID',
  formattedReportType: 'Report Type',
  reportTitleEn: 'Report Title (Eng)',
  facility: 'Facility',
  equipment: 'Equipment',
  isItSafeguard: 'Is the Equipment a Safeguard?',
  consequenceRanking: 'Consequence Ranking',
  status: 'Status',
  step: 'Step',
  discipline: 'Discipline',
  abcPrioritization: 'RIPT Prioritization',
  riptSeriatimRank: 'RIPT Seriatim Rank',
  riskEvaluationScore: 'Risk Evaluation score',
  planApprovalDueDate: 'Plan Approval Due Date',
  daysForApproval: 'Days until Approval Deadline',
  planApprovedDate: 'Plan Approved date',
  resolutionTargetDate: 'Resolution Target date',
  closedOn: 'Report Closed on',
  waitingFor: 'Waiting For',
  initiator: 'Report Initiator',
  createdOn: 'Created On',
  owner: 'Report Owner (Operations Advisor)',
  taRequired: 'TA required',
  ffsPerformed: 'FFS Performed',
  tlrReference: 'TLR reference',
  woReference: 'WO reference',
  mocReference: 'MOC reference',
  dewItReference: 'DEW IT reference',
  damageMechanismsFailureMode: 'Damage Mechanisms/ Failure Modes',
};
